import React from 'react';
import { Snackbar } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import { tmpSelector } from '../../store/redux/modules/tmp/tmpSelector';
import { tmpSlice } from '../../store/redux/modules/tmp/tmpSlice';

// https://callstack.github.io/react-native-paper/snackbar.html
const MessageBar: React.VFC = () => {
	const dispatch = useDispatch();
	const { text, visible } = useSelector(tmpSelector.selectMessage);

	const handleDismiss = () => {
		dispatch(tmpSlice.actions.hideMessage());
	};

	return (
		<Snackbar visible={visible} onDismiss={handleDismiss} duration={3000}>
			{text}
		</Snackbar>
	);
};

export default MessageBar;
